import controller from './migration.controller';

export default {
	path:           '/migration',
	controller,
	controllerAs:   '$ctrl',
	template:       '',
	title:          'Migration',
	reloadOnSearch: true,
};
